import { render } from "./ImageRating.vue?vue&type=template&id=4a01e465"
import script from "./ImageRating.vue?vue&type=script&lang=ts"
export * from "./ImageRating.vue?vue&type=script&lang=ts"
script.render = render

export default script